import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { AngularFireDatabase } from 'angularfire2/database';
import { mergeMap, map, finalize } from 'rxjs/operators';
import { Order } from '../model/order';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AngularFireFunctions } from '@angular/fire/functions';

@Component({
  selector: 'app-submit-order',
  templateUrl: './submit-order.component.html',
  styleUrls: ['./submit-order.component.css']
})
export class SubmitOrderComponent implements OnInit {

  @ViewChild('successModal') private successModal: ElementRef;
  @ViewChild('errorModal') private errorModal: ElementRef;

  constructor(private route: ActivatedRoute, private formBuilder: FormBuilder, private db: AngularFireDatabase,
    private router: Router, private modalService: NgbModal, private firebaseFn: AngularFireFunctions) { }

  orderKey: string;
  deliveryForm: FormGroup;
  order: Order;
  loading: Boolean = false;
  closeResult: string;

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.orderKey = params['key'];
    });

    this.db.object('/order/' + this.orderKey)
      .snapshotChanges().subscribe(
        response => {
          this.order = new Order(response.payload.val());
        }
      );

    this.deliveryForm = this.createForm();
  }

  createForm() {
    return this.formBuilder.group({
      name: ['', Validators.required],
      address: ['', Validators.required],
      state: ['', Validators.required],
      pincode: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', [Validators.required,Validators.email]],
    })
  }

  submitOrder() {
    this.loading = true;
    this.order.name = this.deliveryForm.get('name').value;
    this.order.address = this.deliveryForm.get('address').value;
    this.order.state = this.deliveryForm.get('state').value;
    this.order.pincode = this.deliveryForm.get('pincode').value;
    this.order.phone = this.deliveryForm.get('phone').value;
    this.order.email = this.deliveryForm.get('email').value;

    this.order.status = "SUBMITTED";

    this.db.object('/order/' + this.orderKey).update(this.order).then(
      response => {
        var functions = this.firebaseFn.functions;
        let toEmail =  "bs@lsspi.com;chyehuat@scgmbhd.com;davidcheng@scgmbhd.com";
        const callable = functions.httpsCallable('sendMail');
        var reqBody = {
          "emails": toEmail, 
          "orderkey": this.orderKey, 
          "receipt": this.order.receiptDetails.receiptUrl, 
          "fileName": this.order.receiptDetails.fileName,
          "fileType": this.order.receiptDetails.fileType,
          "order": JSON.stringify(this.order)
        };
        callable(reqBody).then(response =>{
          this.loading = false;
          this.openModal(this.successModal);
          setTimeout(() => {
            this.modalService.dismissAll();
          }, 2000);
          this.router.navigate(['']);
        }).catch(error =>{
          this.loading = false;
          console.log(error);
          this.openModal(this.successModal);
          setTimeout(() => {
            this.modalService.dismissAll();
          }, 2000);
          this.router.navigate(['']);
        });        
      }, error => {
        this.loading = false;
        console.log(error);
        this.openModal(this.errorModal);
        setTimeout(() => {
          this.modalService.dismissAll();
        }, 2000);
      }
    )
  }


  cancelOrder() {
    this.deliveryForm.reset();
  }



  openModal(content) {
    this.modalService.dismissAll();
    this.modalService.open(content, { backdrop: 'static', ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      this.loading = false;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      this.loading = false;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
